import { useState } from "react";

function CreateBuildChapterModal({
  isOpen,
  currentChapterName = "Current Build",
  onCancel,
  onCreate,
  currentStage
}) {
  const [chapterName, setChapterName] = useState("");
  const [copyPhotos, setCopyPhotos] = useState(true);
  const [copyMods, setCopyMods] = useState(true);
  const [copyTimeline, setCopyTimeline] = useState(true);
  const [advancedOpen, setAdvancedOpen] = useState(false);
  const [selectedMods, setSelectedMods] = useState([]);
  

  if (!isOpen) return null;
const currentMods = currentStage?.mods || [];

if (isOpen && selectedMods.length === 0 && currentMods.length > 0) {
  setSelectedMods(currentMods);
}

  const handleCreate = () => {
    if (!chapterName.trim()) return;

onCreate({
  name: chapterName.trim(),
  copyPhotos,
  copyTimeline,
  selectedMods: copyMods ? selectedMods : []
});

    setChapterName("");
    setCopyPhotos(true);
    setCopyMods(true);
    setCopyTimeline(true);
    setAdvancedOpen(false);
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h2 style={{ marginTop: 0 }}>Start New Build Phase</h2>

        <p style={textStyle}>
          Your current build phase, <strong>{currentChapterName}</strong>, will be
          preserved. The new build phase can start as a copy so you can keep
          building without losing history.
        </p>

        <label style={labelStyle}>New Build Phase Name</label>

        <input
          value={chapterName}
          onChange={(e) => setChapterName(e.target.value)}
          placeholder="Example: Turbo Build"
          style={inputStyle}
        />

        <div style={examplesStyle}>
          Examples: OEM+, Street Build, Track Setup, Widebody, Engine Rebuild
        </div>

        <div style={optionBoxStyle}>
          <label style={checkboxLabelStyle}>
            <input
              type="checkbox"
              checked={copyPhotos}
              onChange={(e) => setCopyPhotos(e.target.checked)}
            />
            Copy photos
          </label>

          <label style={checkboxLabelStyle}>
<input
  type="checkbox"
  checked={copyMods}
  onChange={(e) => {
    const checked = e.target.checked;

    setCopyMods(checked);

    if (checked) {
      setSelectedMods(currentMods);
      setAdvancedOpen(false);
    } else {
      setAdvancedOpen(true);
    }
  }}
/>
            Carry over all mods
          </label>

          <label style={checkboxLabelStyle}>
            <input
              type="checkbox"
              checked={copyTimeline}
              onChange={(e) => setCopyTimeline(e.target.checked)}
            />
            Copy timeline
          </label>
        </div>

{copyMods ? (
  <button
    type="button"
    onClick={() => setAdvancedOpen(!advancedOpen)}
    style={advancedButtonStyle}
  >
    {advancedOpen
      ? "▲ Customize carried-over mods"
      : "▼ Customize carried-over mods"}
  </button>
) : (
  <div style={advancedHintStyle}>
    Individual mod selection is enabled below.
  </div>
)}

{advancedOpen && copyMods && (
  <div style={modSelectBoxStyle}>
    {(currentStage?.mods || []).length > 0 ? (
      currentStage.mods.map((mod) => (
        <label key={mod.id} style={modCheckboxStyle}>
<input
  type="checkbox"
  checked={selectedMods.some((selectedMod) => selectedMod.id === mod.id)}
  onChange={(e) => {
    if (e.target.checked) {
      setSelectedMods([...selectedMods, mod]);
    } else {
      setSelectedMods(
        selectedMods.filter((selectedMod) => selectedMod.id !== mod.id)
      );
    }
  }}
/>
          <span>
            {mod.partName}
            {mod.brand ? ` — ${mod.brand}` : ""}
          </span>
        </label>
      ))
    ) : (
      <p style={emptyModsStyle}>No mods in this chapter yet.</p>
    )}
  </div>
)}

        <div style={buttonRowStyle}>
          <button onClick={onCancel} style={cancelButtonStyle}>
            Cancel
          </button>

          <button
            onClick={handleCreate}
            style={{
              ...createButtonStyle,
              opacity: chapterName.trim() ? 1 : 0.5,
              cursor: chapterName.trim() ? "pointer" : "not-allowed"
            }}
            disabled={!chapterName.trim()}
          >
            Create Build Phase
          </button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.82)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 30000,
  padding: "20px"
};

const modalStyle = {
  backgroundColor: "#181818",
  border: "1px solid #333",
  borderRadius: "20px",
  padding: "22px",
  maxWidth: "420px",
  width: "100%",
  boxSizing: "border-box",
  color: "white"
};

const textStyle = {
  opacity: 0.85,
  lineHeight: "1.6"
};

const labelStyle = {
  display: "block",
  fontWeight: "bold",
  marginTop: "18px",
  marginBottom: "8px"
};

const inputStyle = {
  width: "100%",
  padding: "14px",
  borderRadius: "12px",
  border: "1px solid #333",
  backgroundColor: "#1f1f1f",
  color: "white",
  boxSizing: "border-box"
};

const examplesStyle = {
  fontSize: "12px",
  opacity: 0.65,
  marginTop: "8px",
  lineHeight: "1.5"
};

const optionBoxStyle = {
  backgroundColor: "#1f1f1f",
  border: "1px solid #2a2a2a",
  borderRadius: "14px",
  padding: "14px",
  marginTop: "18px",
  display: "flex",
  flexDirection: "column",
  gap: "10px"
};

const checkboxLabelStyle = {
  display: "flex",
  gap: "10px",
  alignItems: "center"
};

const buttonRowStyle = {
  display: "flex",
  gap: "10px",
  marginTop: "22px"
};

const cancelButtonStyle = {
  flex: 1,
  backgroundColor: "#333",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer"
};

const createButtonStyle = {
  flex: 1,
  backgroundColor: "#e10600",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold"
};

const advancedButtonStyle = {
  marginTop: "8px",
  backgroundColor: "#111",
  color: "white",
  border: "1px solid #333",
  borderRadius: "10px",
  padding: "12px",
  fontWeight: "bold",
  cursor: "pointer",
  textAlign: "left"
};

const modSelectBoxStyle = {
  marginTop: "10px",
  backgroundColor: "#151515",
  border: "1px solid #2a2a2a",
  borderRadius: "12px",
  padding: "12px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  maxHeight: "220px",
  overflowY: "auto"
};

const modCheckboxStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  fontSize: "14px",
  lineHeight: "1.4"
};

const emptyModsStyle = {
  opacity: 0.65,
  margin: 0,
  fontSize: "14px"
};

const advancedHintStyle = {
  marginTop: "10px",
  fontSize: "12px",
  opacity: 0.7,
  fontStyle: "italic"
};

export default CreateBuildChapterModal;